import React from "react";
import "./header.scss";
import { PageTitle, Subtitle } from "@ddm-design-system/typography";
import OutletPicker from "../outlet_picker/OutletPicker";
import Profile from "../profile/Profile";
import useIsMobile from "../../../hooks/useIsMobile";

interface IProps {
  showOutletPicker?: boolean;
  title?: string;
}

const Header: React.FC<IProps> = ({ title, showOutletPicker }) => {
  const isMobile = useIsMobile();
  const Title = isMobile ? Subtitle : PageTitle;
  return (
    <div className="header">
      {(title && <Title>{title}</Title>) || (!showOutletPicker && <div />)}
      {showOutletPicker && <OutletPicker />}
      <Profile />
    </div>
  );
};

export default Header;
